import React from 'react'
import PropTypes from 'prop-types'

import { ContextHeadline } from '@aok/text-elements'
import { SecondaryButton, PrimaryButton } from '@aok/ui-elements'

import defaultProps from '../../../../utils/propTypes/defaultProps'

const M047QuestionLayout = ({
  headline,
  subtitle,
  children,
  onNextButtonClick,
  onPreviousButtonClick,
  nextButtonDisabled,
  nextButtonLabel,
}) => {
  return (
    <div className="px-16 720:px-48 1000:px-64" aria-live="polite" role="region">
      {/* Header */}
      <ContextHeadline
        text={headline.text}
        tag={headline.tag}
        className="
          text-24 leading-32 text-005e3f
          font-semibold font-buenos-aires mt-8"
      />
      {subtitle && <p className="mt-8">{subtitle}</p>}

      <form onSubmit={(e) => e.preventDefault()}>
        {/* Content */}
        <div className="mt-32 600:mt-40">{children}</div>

        {/* Footer */}
        <div className="flex justify-end items-end gap-x-16 mt-40 600:mt-48">
          <SecondaryButton className="w-full 600:w-auto" onClick={onPreviousButtonClick}>
            Zurück
          </SecondaryButton>
          <PrimaryButton
            type="submit"
            className="w-full 600:w-auto"
            onClick={onNextButtonClick}
            isDisabled={nextButtonDisabled}
          >
            {nextButtonLabel}
          </PrimaryButton>
        </div>
      </form>
    </div>
  )
}

M047QuestionLayout.propTypes = {
  headline: PropTypes.shape({
    text: PropTypes.string,
    tag: PropTypes.string,
  }),
  subtitle: PropTypes.string,
  children: PropTypes.node,
  onNextButtonClick: PropTypes.func,
  onPreviousButtonClick: PropTypes.func,
  nextButtonDisabled: PropTypes.bool,
  nextButtonLabel: PropTypes.string,
}

M047QuestionLayout.defaultProps = {
  headline: {
    text: defaultProps.HEADLINE,
  },
  onNextButtonClick: () => {},
  navigateToPreviousPage: () => {},
  nextButtonLabel: 'Weiter',
}

export default M047QuestionLayout
